module.exports = __webpack_public_path__ + "static/media/calculator.f6675932.svg";